var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2048 2048",
    width: 128,
    height: 128,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1166,253)",
    d: "m0 0 4 1 1 2 1 129 1 253 3 1-1-14v-201l2-6 7-2 32 1 17 3 12 5 11 7 12 12 9 13 4 10 5 31v153l1-12 1-86 1-38 3-11 5-3 7 1 16 10 11 9 8 8 12 16 7 14 2 10 1 20 1 445h2l1 9h3l2-10 8-35 8-26 28-82 12-36 12-37 4-5 4 1 5 5 5 10 7 16 6 9 8 6 12-2 16-7 21-6 8-4 7 2 5 4 11 20 10 14 7 11 7 9 5 4 5-1 16-8 14-5 12-5 12-6 7 1 5 4 6 10 4 9 7 11 11 22 4 2 10-1 10-6 29-10 10-6 8-2 7 3 7 11 12 23 6 9 7 4 8-1 19-5 16-7 10-4h8l1 4-14 42-13 43-13 40-14 41-16 49-13 40-12 36-27 82-17 51-3 4h46l121 1 8 2 9 7 7 11 5 12 1 8 1 45v250l-1 38-2 17-5 12-6 8-7 3-13 2-20 1-57 1h-128l-38-1-80-1-237-1h-1166l-10-2-3-4-3-26v-41l4-12 2-5v-11l-3-12-2-4-1-6v-38l2-21 2-10 2-2 184-1 21-1 5-3 9-26 8-20 5-9 12-16 9-10 7-8 8-7 12-9 9-6 1-21v-844l1-52 3-10 10-17 8-10 10-10 11-8 18-7 10-1 5-13 5-26 9-15 10-11 5-5 10-7 11-7 4-1 54-2 4-2 1-29 1-124 2-6 8 1 38 15 29 11 11 3 13-1 19-10 19-8 16-9 9-3 9 1 17 5 21 8 16 6 18 8 16 4 12-2 21-8 36-12 22-8 4-1h11l19 5 34 14 20 9 11 3 9-1 42-15 16-6 22-10zm199 1123 1 2zm0 3m346 0m-33 1v1h19v-1zm24 0v1h9v-1zm-336 0-81 1-1 3 130 1h174l85-3v-1h-204zm-869 82 1 2z",
    fill: "#FE3137"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1737,1379)",
    d: "m0 0h145l8 2 9 7 7 11 5 12 1 8 1 45v250l-1 38-2 17-5 12-6 8-7 3-13 2-20 1-57 1h-128l-38-1-80-1-237-1-76-1-9-9-5-4-3-9-2-27-1-104v-50l2-126v-40l1-18 3-9 5-4 18-5 27-4 135 1h174l54-2 51-1 21-1h15l5 2 2 2z",
    fill: "#A9D9F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1285,498)",
    d: "m0 0h1v153l1-12 1-86 1-38 3-11 5-3 7 1 16 10 11 9 8 8 12 16 7 14 2 10 1 20 1 445h2l1 9h3l2-10 8-35 8-26 28-82 12-36 12-37 4-5 4 1 5 5 5 10 7 16 6 9 8 6 12-2 16-7 21-6 8-4 7 2 5 4 11 20 10 14 7 11 7 9 5 4 5-1 16-8 14-5 12-5 12-6 7 1 5 4 6 10 4 9 7 11 11 22 4 2 10-1 10-6 29-10 10-6 8-2 7 3 7 11 12 23 6 9 7 4 8-1 19-5 16-7 10-4h8l1 4-14 42-13 43-13 40-14 41-16 49-13 40-12 36-27 82-17 51-3 4h46v1h-24v7l-4-4-4-1h-36v1h-224l-103-1-81 1-6 2-27 4-18 5-5 5-2 7-1 25v42l-2 117v64l1 90 2 27 3 10-2 1-4-12-1-7-1-19-1-68v-123l2-149 4-9 4-3 19-5 21-3 12-2v-751l1-105v-16zm80 878 1 2z",
    fill: "#FEE4A7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(508,493)",
    d: "m0 0h1l1 8 1 20 1 43v151l-1 184v554l26 3 21 5 19 6 10 4 3 3 13 5 17 10 9 7 18 18 10 13 9 15 5 10v2h2l5 11 2 9 4 19 2 13v37l-5 25-5 16-8 17-9 15-12 16-15 16-9 8-21 14-16 8-19 9-13 4v1l-19 1h-382l-10-2-3-4-3-26v-41l4-12 2-5v-11l-3-12-2-4-1-6v-38l2-21 2-10 2-2 184-1 21-1 5-3 9-26 8-20 5-9 12-16 9-10 7-8 8-7 12-9 9-6 1-21v-844l1-52 3-10 10-17 8-10 10-10 11-8 18-7 10-1zm-11 969 1 2z",
    fill: "#FDEA44"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1166,253)",
    d: "m0 0 4 1 1 2 1 129 1 254-20 2-236 1h-246l-43-1-4-3-1-8-1-157-2-56-3-1 4-2 1-29 1-124 2-6 8 1 38 15 29 11 11 3 13-1 19-10 19-8 16-9 9-3 9 1 17 5 21 8 16 6 18 8 16 4 12-2 21-8 36-12 22-8 4-1h11l19 5 34 14 20 9 11 3 9-1 42-15 16-6 22-10z",
    fill: "#FFE4A6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(677,737)",
    d: "m0 0h502l4 2 1 4 1 26v240l-1 12-5 2h-559l-7-1-3-5-1-15v-158l1-94 1-9 2-2 9-1z",
    fill: "#E9EAFE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1737,1379)",
    d: "m0 0h145l8 2 9 7 7 11 5 12 1 8 1 45v250l-1 38-2 17-5 12-6 8-7 3-13 2-20 1-57 1h-128l-7-1-2-2-5 1h-8l-8-7-9-10-26-26-7-9-11-14-11-16-10-13-6-10-6-13 1-5-3-1-4-14v-7l8-5 25-10 36-13 19-7 7-1-1-6-10-29-7-27-5-23-4-39-11-1-24-1-16-2-13-4-1-1v-7l5-11 3-3 8-1 41 2h8l2-1 2-36 5-26 3-8 3-2 24-1 1 7-3 24-1 5-1 21v17l9-1 23-6 31-7 33-8h2l-3-10-6-15-4-13-3-14z",
    fill: "#87EA2D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1672,375)",
    d: "m0 0h21l25 3 21 5 20 8 17 9 12 8 12 9 13 12 11 12 13 18 9 16 7 15 7 21 4 18 2 14v28l-4 24-6 20-7 18-9 16-12 18-8 10-6 7-8 7-7 7-16 11-16 9-21 9-21 6-25 4-19 1-18-1-22-4-23-7-23-11-14-9-12-9-14-13-11-9-10 1-22 6-38 8-25 7-4-1 8-10 10-14 11-13 9-11 12-13 10-13 4-6v-10l-6-31-1-9v-19l4-27 7-24 9-22 11-18 8-11 11-13 14-14 15-11 15-10 16-8 19-7 23-5z",
    fill: "#A9DAF2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(508,493)",
    d: "m0 0h1l1 8 1 20 1 43v151l-1 184v554l26 3 21 5 19 6 2 2-9-2-25-7-17-3-10-1h-19l-1 2h-11l-41 8-12 3v12h-1v-863l1-52 3-10 10-17 8-10 10-10 11-8 18-7 10-1z",
    fill: "#FDA7AA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1285,498)",
    d: "m0 0h1v153l1-12 1-86 1-38 3-11 5-3 7 1 16 10 11 9 8 8 12 16 7 14 2 10 1 20 1 445h2v17l-2 30-1 28-2 40-1 45-1 166-2 19-2 1-21 1-47 1-6 2-27 4-18 5-5 5-2 7-1 25v42l-2 117v64l1 90 2 27 3 10-2 1-4-12-1-7-1-19-1-68v-123l2-149 4-9 4-3 19-5 21-3 12-2v-751l1-105v-16z",
    fill: "#FEA8AA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(348,1597)",
    d: "m0 0h1l8 55 6 29 3 10-1 5-22 1h-140l-39-1-20-1-4-15-2-4-1-6v-38l2-21 2-10 2-2 184-1z",
    fill: "#FE9015"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1796,1584)",
    d: "m0 0h6l2 1 5 13 4 13 6 18 4 10 4 12 8 20 3 7v6l-9 3-17 5-25 12-12 7-18 13-14 9-6 2-10-17-6-11-14-24-8-14-7-11-8-16-5-9v-5l8-3 17-6 34-15 30-11z",
    fill: "#009EFE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1648,1639)",
    d: "m0 0h9l3 5 6 16 9 20 9 16 6 11 6 9 8 14 6 11 6 9v5l-9 7-15 9-12 9-6 5-5 5-4 3-5 1h-8l-8-7-9-10-26-26-7-9-11-14-11-16-10-13-6-10-6-13 1-5 11-4 16-6 25-10 28-10z",
    fill: "#019EFE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1756,1461)",
    d: "m0 0h4l7 25 3 8 6 15 7 21 6 13 5 12-1 5-16 6-30 10-44 16-29 10-4 1-2-10-5-21-7-29-6-30v-20l4-4 44-10 19-5 21-6z",
    fill: "#009EFE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1554,1473)",
    d: "m0 0h1l1 7 13 4 16 2 24 1 11 2 2 10 3 29 5 23 8 30 9 26 1 4-1 2-15 5-28 10-32 12-16 7h-6l-4-16-6-37-2-17v-36l4-27 6-24z",
    fill: "#009EFE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1893,1385)",
    d: "m0 0 4 1 7 9 6 13 2 11 1 45v53l-15 4-27 10-22 9-21 8-4 2-5-1-6-20-10-26-11-27-6-20v-5l24-10 21-10 16-8 26-15 11-8 6-7z",
    fill: "#009EFE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(867,1523)",
    d: "m0 0 51 1 18 2 9 3 1 1 1 13v57l-1 27-3 7-7 3-6 1-35 1h-46l-8-2-3-3-2-8-1-9v-78l2-9 5-4 6-2z",
    fill: "#FCFCFD"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(642,1319)",
    d: "m0 0h43l35 1 12 2 3 2 1 4v90l-2 10-5 3-6 1-48 1h-34l-10-1-5-5-1-3-1-11-1-61 1-22 3-7 9-3z",
    fill: "#FCFCFE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1065,1524)",
    d: "m0 0h70l17 2 3 1 2 5 1 15v78l-3 7-3 3-10 2-51 2h-31l-8-1-3-7-2-15-1-22v-48l1-13 5-7z",
    fill: "#FCFCFE"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1066,1320)",
    d: "m0 0h84l6 2 1 2 2 20v70l-1 9-2 4-7 3-6 1-59 2h-16l-16-1-5-6-2-22 1-62 1-14 4-5 7-2z",
    fill: "#FCFCFE"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1083,1115)",
    d: "m0 0h57l13 3 5 3 1 2 1 11v30l-1 33-1 18-2 7-6 3-5 1-16 1-52 1-18-1-7-1-2-2-3-10-1-10v-60l1-17 1-5h2l2-4 7-2z",
    fill: "#FCFCFE"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(848,1320)",
    d: "m0 0h58l25 1 11 2 3 5 2 15v64l-1 15-3 6-8 3-7 1-28 1h-53l-9-3-2-3-1-6v-90l3-6z",
    fill: "#FCFCFE"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(641,1116)",
    d: "m0 0h77l11 1 5 4 2 5 1 39-1 43-2 13-3 4-3 1-13 1h-78l-7-3-4-4-2-10-1-43v-15l1-26 2-6 7-3z",
    fill: "#FCFCFD"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(882,1115)",
    d: "m0 0h40l12 1 10 5 3 7v72l-1 15-3 8-7 3-10 1h-78l-9-3-3-4-1-5v-84l1-8 6-5 5-2z",
    fill: "#FCFCFE"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(308,979)",
    d: "m0 0 11 1 5 2 1 2v364l-1 46-5 2h-9l-9-2-3-5-1-16-1-101v-284l2-6 3-2z",
    fill: "#323E5D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1654,1386)",
    d: "m0 0h5l1 7-3 24-1 5-1 21v17l9-1 23-6 31-7 33-8h2l-3-10-1-5 3 4 3 6 1 3-2 4-4 1-1 4-7 3h-2l-1-2-13 1-4 2 3 3 7 3 1-2 1 7-1 1-9 2-3 2-11 2-6 3-9 2-5 3-4 1 1 3 10-2 1-1 15-3 16-4 24-8 3-2 5 1 3 7 4 16 3 10 6 15 7 20 7 16 6 13-2 4-12 5-14 4h-5l3-2 19-6 7-3-1-6-8-19-6-15-5-15-5-12-5-17-3-11v-3l-16 6-19 6-24 6-47 11-3 3v20l4 20 7 30 6 27 2 5v8l15-6 27-9 13-5 3 1-8 4-26 9-7 3-10 3-6 4-4-1v-3l-7 3-8 3-4 5-12 4-9 4-8 2-4-1 20-7 9-3h3l-1-6-10-29-7-27-5-23-4-39-11-1-24-1-16-2-13-4-1-1v-7l5-11 3-3 8-1 41 2h8l2-1 2-36 5-26 3-8 3-2z",
    fill: "#61E65B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1912,1536)",
    d: "m0 0h1v178l-1 38-2 17-5 12-5 7-2-2v-12l-4-16-7-18-9-24-5-18 1-5 16-8 15-7 4-2v-9l-6-5-1-2h-9l-16 6-6 4-3-1-9-17-8-20-11-25-10-24-2-6 4-4 33-15 23-10 16-8z",
    fill: "#03ADFD"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1714,1380)",
    d: "m0 0h15l5 2 2 4h2l4 17 5 15 6 15v5l-13 4-45 10-16 4-19 5h-5l-1-1v-17l1-21 3-18 1-18-5 1-19 1-3 2-5 21-2 12-2 36-3 2-27-1-24-1-7 2-3 5-3 4 2-9 7-14 13-22 15-24 8-11 5-6 10-1 26-1 51-1z",
    fill: "#009EFE"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(805,400)",
    d: "m0 0h164l56 1 27 1 15 2 7 2 1 2-1 9-1 8-2 2-6 1-117 1h-101l-90-1-28-1-3-9v-9l4-4 17-3 16-1z",
    fill: "#394A69"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1317,1467)",
    d: "m0 0h42l27 1 9 1 3 2 1 8v15l-1 35-1 20-2 6-12 2-26 1h-17l-19-1-10-2-2-2-1-18v-41l1-25 1-1z",
    fill: "#384968"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1474,975)",
    d: "m0 0 13 1 23 6 21 5 46 14 50 16 63 21 34 13 11 8 2 4-6 12h-2l-2 4h-9l-40-12-30-10-20-6-30-10-13-4-28-10-23-8-25-9-29-9-9-6-1-12 3-7z",
    fill: "#405A80"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1444,1061)",
    d: "m0 0h8l21 5 33 10 26 8 5 2v2l9 2 12 4 14 3 40 13 27 8 28 9 12 4 11 5 13 7 1 5-1 9-4 8-2 1-15-1-7-3-17-5-32-10-30-10-18-5v-3l-7-1-9-3-7-2-54-18-12-3-12-5-6-2-18-5v-2l-11-2-3-6 2-13z",
    fill: "#3F4D6B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1156,740)",
    d: "m0 0h26l1 5v67h-2v189l-3 2-4-2-1-6-3-12v-4l-4-1-1-3h-2l1 3-4-2-1-11-1-4 3-4-2-15 3-7 1-9 4-3v-2l-3-3-3-12 6-4-2-6-3-3v-3h5l-1-4-2-2 1-2h-2l-2-5 1-2 6 1-1-5-3-3h-5v-4l1-5-3-1-1-7-1-1-2-10h-2l-2-5 3-4 1-5-6-1-4-10 1-2h7l-4-4-3-1-1 3-5-1-1-3h2v-8l-10-3-2-9 5-2 1-5-4-2-1-2v-3l-2-1-1 1h-1l1-7 3-6h2v-5h-3l-11-4-3-1v-2l20-4 17-2z",
    fill: "#DDEDFD"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(514,1541)",
    d: "m0 0h8l10 4 5 4v2l4 2 8 11 6 12 3 7 2 5v10l-4 1-9-3-6-8-9-4-13-6h-7l-8 6-4 4-1 3v7l6 9 7 4 28 10 12 6 4 5 5 10 1 5v11l-2 10-8 16-9 13-7 6-10 5-4 1h-10l-9-4-11-12-6-10-6-16-3-11 1-5 9 2 10 4 5 4 10 3 8 3 5-1 4-4 4-9v-12l-8-5-8-3-10-3-11-7-8-7-7-14-1-10 2-12 8-13 8-11 4-5h2v-2z",
    fill: "#FF9015"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(746,502)",
    d: "m0 0h171l17 1 10 2 1 1v16l-1 12-4 1h-202l-8-3-5-6-2-5 1-9 4-6 7-3z",
    fill: "#465B80"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1839,1702)",
    d: "m0 0 4 1 5 11 5 15 6 16 8 16 9 17 3 6 1 3 6 5v1l-7 1-20 1-57 1h-23v-1l10-3-1-5-14-15-14-14 1-5 13-12 10-7 12-7 18-11 11-6z",
    fill: "#009EFE"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1414,1150)",
    d: "m0 0 15 2 39 10 42 13 18 5 18 6 16 5 5 3v2h8l31 11 33 11 24 9 12 6 1 5-1 2-3 1v5l-4 3h-8l-15-3-45-14-72-24-35-12-28-10-37-12-8-2-6-4-2-2v-12z",
    fill: "#394A69"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1887,1557)",
    d: "m0 0 4 1-3 6h2l2 4v30l3 14 3 8 2 10-1 14-5 10-3 4-10 4-6 2h-8l-3-5-3-3-7-16-8-20-12-27-6-16 4-4 29-13 4 1-1 2 12-2z",
    fill: "#009EFE"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1756,500)",
    d: "m0 0 5 1 9 4v7l-9 15-8 12-9 9-5 6-8 7-8 8-7 8-11 11h-2v2l-17 9-12 1-9-4-9-9-2-1v-2h-2v-2h-2v-2h-2v-2h-2l-6-10-6-17 3-4 8-1 11 2 10 11v2h9l6-2 11-1 4-4h2l2-5 8-7h2l2-4 4-5h2v-2l11-9h2l2-4 11-9 5-3 1-3z",
    fill: "#405A80"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1289,603)",
    d: "m0 0h1l1 10v28l1 13-1 11 1 11v38l1 8v35l1 13-1 5v103l-1 8v18l1 4-1 10v34l-1 39v23 2 17l-1 3v15l1 7-1 13v19l-1 16v7l1 1-1 20v36l-1 192v18l-4 3-32 5-18 5-5 5-2 7-1 25v42l-2 117v64l1 90 2 27 3 10-2 1-4-12-1-7-1-19-1-68v-123l2-149 4-9 4-3 19-5 21-3 12-2v-751h1l1 529 1-112 1-114 1-263z",
    fill: "#FE9F89"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1840,1700)",
    d: "m0 0 5 2 2 6 4 1v8l3-1 2 1-2 4 1 8 6 16 11 23-1 2-10-19-5-11-4-11-7-20-3-6-5 1-14 8-18 10-15 10-12 7-10 9-7 6 1 5 22 22 6 8-1 4-10 3h-105l-7-1v-4l5-4 5-6 18-13 18-11 2-2-1-7-6-9 1-2 8 11 2 3 1 7 3 1 1 5 3 1 3-2h11l8 2 8-1-1-10 7-6 8-7 10-8 12-6 18-11 17-10z",
    fill: "#61E65B"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1758,492)",
    d: "m0 0 10 4v2l5 1 3 5v11l-2 11-8 7-7 11-6 7-1 2h-2l-2 5-4 6-6 5h-2l-2 4-6 7-7 6h-2v2l-8 6-7 5-17 8-6 1-14-3-9-4v-2l-4-2-11-10-9-13-4-10-1-11 2-8 10-6 10-1 8 2h28l12-6 7-4 5-7h2v-2l9-6 7-8 5-3 8-7 3-2 6-2zm-2 8-6 3-1 3-14 10-4 4v2l-4 2-9 7v2l-3 1-5 6v2l-4 2-6 5-2 5-3 1-3 3-11 1-9 2h-6l-2-4-8-9-11-2-8 1-3 5 7 18 5 8h2v2h2v2h2v2h2v2l8 7 4 4 8 3 12-1 17-9v-2l4-2 15-15 7-8 6-5 6-7 13-13 7-11 9-15v-7l-10-5z",
    fill: "#98C7DC"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(677,737)",
    d: "m0 0h502l4 2 1 4v24h-1l-1-22-1-5h-535l-28 1-4 1-1 41-1 140v73l1 19 2 4 17 1h550l1-162 1-89h1v240l-1 12-5 2h-559l-7-1-3-5-1-15v-158l1-94 1-9 2-2 9-1z",
    fill: "#FEA6A0"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(617,416)",
    d: "m0 0h5l2 9 1 15 1 8 1 76v108l2 4 5 1h144l97-1h284l10-2v-198l1-8 2 1 1 210-20 2-236 1h-246l-43-1-4-3-1-8-1-157-2-56z",
    fill: "#FE9F89"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(508,493)",
    d: "m0 0h1l1 8 1 20 1 43v151l-1 184v554l26 3 21 5 19 6 2 2-9-2-25-7-17-3-10-1h-19l1-3h9l-2-26v-56l1-79v-52l-1-94v-514l1-38-1-82z",
    fill: "#FE9E88"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1752,1379)",
    d: "m0 0h122l-3 2-11 6-8 7-23 12-28 13-22 9-3-1-8-16-9-21z",
    fill: "#009EFE"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1284,499)",
    d: "m0 0h1v41l-1 90v751h-3l1-8-1-53v-38l-1-2v-96l-1-48v-26l-1-2 1-8v-148l-1-19v-11l-1-3 1-3-1-2h2l-2-6 1-4v-13l-1-4 1-4v-11l1-5v-21l-1-6 1-22-1-14 1-12-1-24 1-20-1-20 1-8-1-20 1-24v-48l1-10v-64l-1-11 1-4-1-3 1-2v-26l2-4z",
    fill: "#FF4852"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(301,810)",
    d: "m0 0 18 1 5 2 1 6v60l-1 40-4 1h-14l-7-2-2-4v-103z",
    fill: "#323D5D"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1017,501)",
    d: "m0 0 46 1 10 2 3 3v10l-3 14-4 3-13 1h-40l-25-2-4-4-1-4v-12l2-7 8-3z",
    fill: "#405A80"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1893,1385)",
    d: "m0 0 4 1 7 9 6 13 2 11 1 45v53l-15 4-27 10-22 9-21 8h-3l3-4 13-4 38-15 19-8 2-6 3-14 1-10-5-14-5-7-5-14-3-12-3-7-3-13v-5l-7-1-1-2 1-2-2-1 12-8 7-8z",
    fill: "#01ADFD"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(611,739)",
    d: "m0 0 2 1-1 1-1 10-1 93v158l1 15 2 4 7 1 559 1-3 2-9 1-4 1h-2v-2h-2v2h-2v-2l-5 1-12-1-1 2-4-1-4 1-2-2v2h-22v-2l-3 1-4-1-1 2-7-1h-38l-6-1h-34l-72 1-4 1-3-1-8 1-3-1-1 1h-7-1-8-4l-3-1-9 1-3-1-7 1-5-1h-64v-2l-10 1-1 2-10-1h-15l-5 1h-34l-3 1-6-1-8 2-1-1h-10v2l-11 1-5-2-1 2h-6l-7 1h-17l-12-1-8 1-10-2-1-2-7-1h-3l-10-2-3-12-1-47-1-103v-53l-1-16v-45l2-7z",
    fill: "#FE4751"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1414,1150)",
    d: "m0 0 15 2 39 10 42 13 18 5 18 6 16 5 5 3v2l4 2-4 1h-8l-3 1-5-1h-15l-1-5 1-4-10-1-4-3-14-1 3 2 11 3-1 5 3 1-3 3h-2v-2l-4-1v-5l-3 1-7-2h-5l-5-1-4-2-5 1-2 1h-10l-46-15-8-2-6-4-2-2v-12z",
    fill: "#333F5E"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1414,1170)",
    d: "m0 0 6 1 24 7 47 16 19 7 57 19 43 14 35 11 15 3h8l3-3 1-5h3v-6l-16-8-18-6-28-10-36-12-10-2v-2l-4-2 10 2 30 10 35 12 15 6 11 4 12 5 3 4-1 5-3 9-11 4h5l-4 3h-8l-11-4-17-3-6-2-10-2-11-4-9-3-5-1-6-3-7-1-9-2-10-4h-3v-2l-9-1-9-3-4-2-6-1-11-4-9-4-7-2-6-2-4-1-5-3-5-1-19-7-6-2-22-8-9-5-7-5z",
    fill: "#FF9F89"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1577,1013)",
    d: "m0 0 7 2h17l9 3 5 10v2l9 3h5l3-3h2l1-3 7 1 18 5 7 3 9 3 32 10 3 2-1 9 4 2v2h2l1 3 3 3-3 2-26-5-15-6-10-2-30-10-7-4-17-4-9-4-9-2-3-2v-5h-3v-2h-2v-2l-4-2-5-5z",
    fill: "#394A69"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1616,1383)",
    d: "m0 0h43v2l-19 1-5-1h-4l1 3h-2l-1 7-2 4-4 4-3 7-2 14-2 26-4 3-12 2h-12l-9-4-2-3-2-8h-2l1-6 3-7 14-23 10-14 5-6z",
    fill: "#019EFE"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(776,418)",
    d: "m0 0h24l6 1h58l1 1h18l36 1h58l32-1h29l7-1h10l5 1h6v2l5-1v4l-6 3-117 1h-101l-50-2h-18l-38-2v-3l9-3z",
    fill: "#2F3D5D"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1444,1061)",
    d: "m0 0h8l21 5 33 10 13 4v3l2 1-4 4 2 5 5 4 1 4 4 2 6 4v3l5 1 4 3-1 4-10-2-32-11-12-3-12-5-6-2-18-5v-2l-11-2-3-6 2-13z",
    fill: "#3D4C6A"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(838,397)",
    d: "m0 0h135l61 1 21 1 16 3 6 4 1 5-3 15 2-3-1 5-7 3-11 1-70 1-194-1-52-1-14-1-3-6v-16l1-3 8-4 7-1 43-2zm-33 3-42 1-23 2-10 2-4 4v9l3 9 28 1 90 1h116l102-1 7-2 1-1 2-11v-6l-1-2-11-3-11-1-27-1-56-1z",
    fill: "#A67C84"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1864,1557)",
    d: "m0 0 3 1-32 15-5 2-1 3 12 29 11 25 6 15 11 22 5-2 10-5 9-3h9l4 5 4 3v9l-5 3-16 8-11 5-3 1-1 5 6 21 14 37 1 6-2-3-7-18-9-23-3-9-3-12v-8l-1-3-1-11-3-5-8-16-7-16-5-14-9-19-4-9-3-4v-2h-2v-2l-5 2 1 6-1 6-9 2 1 9 10 27 6 17 6 15 3 6v6l-5 3-22 6-3-1 15-5 12-3-1-9-8-18-9-27-3-7-4-12-5-17-3-6v-3h-8l-36 12-27 10-29 13-17 6-7 2 1 7 7 12-1 3-9-16-2-5 1-4 13-3 21-8 30-13 48-17 9-3 12-2 10-5 11-3 13-5 10-5z",
    fill: "#61E65C"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1714,1380)",
    d: "m0 0h15l5 2 2 4h2l4 17 5 15 6 15v5l-13 4-45 10-16 4-19 5h-5l-1-1v-17l1-21 3-18 1-18-5 1-19 1-3 2-5 21-2 12-2 36-3 2-27-1-24-1-7 2-3 5-3 4 2-9 7-14 9-15 1 2-2 6h2l2 3 2 7 9 4h12l12-2 3-2 2-26 3-17 5-8 2-1 3-10 1-3 7-1 4 1h17v-2h-17v-1h31l-3 2-1 9-2 6-2 15-4 19-2 10v12h12l19-5 22-5 28-8 4-2 1-15-5-5-4-10-8-15-5-4-13-2-1-1-16-1v-1z",
    fill: "#02ADFD"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1285,498)",
    d: "m0 0h1v153l1-12 1-36h1v67l-1 274-1 113-1 155h-1l-1-69v-634z",
    fill: "#FEA7A8"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(805,400)",
    d: "m0 0h164l56 1 27 1 15 2 7 2 1 2-1 9-1 8h-1l-1-7-8-6v-2l-10-1h-36l-12-1h-47l-4-1-4 1h-13l-16-2h-8l-13-2h-33l-7 1-8-1h-13l-31 1-2-1v2h-2v-2l-12 1-9 1h-28l-15 1-4 3-2 4-2 1-2 10 6 1v1h-7l-3-9v-9l4-4 17-3 16-1z",
    fill: "#405A80"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1478,978)",
    d: "m0 0h9l10 3 12 2 19 5 3 1 1 2 13 5 18 6 2 9 3 3v2l4 2 6 8-1 2-10-2-9-4-11-3-5-6-5-3-5 1h-8l-11-4-7-3-23-7-8-5-2-4v-7z",
    fill: "#394A69"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1355,1462)",
    d: "m0 0h30l13 1 4 3 1 52v18l-2 18-2 4-5 2-14 2-40 1h-13l-14-2-6-3-2-3-1-16 1-47 2-25 3-2 18-2zm-38 5-7 1-1 1-1 25v41l1 18 4 3 8 1 25 1h21l16-1 12-2 2-6 1-20 1-35v-15l-1-8-3-2-9-1-27-1z",
    fill: "#98C7DC"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(641,1403)",
    d: "m0 0h2v4l6 2v2h2v2l4-1 4 6 2 2 6 1-2-2-5-1 4-2 5-1 6-2h5l2-2 16-1 10 1 6 2 1 2 5 2 1 2v7h9l1-1 1-8h1v10l-3 2-9 1-79 1-8-1v-1h6l-1-5v-3l-3-1v-11z",
    fill: "#E9EAFE"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1554,1473)",
    d: "m0 0h1l1 7 13 4 16 2 24 1 11 2 2 10 3 29 5 23 6 22v5l-3-4-4-15-3-7-3-3-4-13-2-8-4-11-2-7-6-6-2-4-5-2-9 3h-10l-8-4v-2l-12 1-2 1-2 4-7 1h-2l1-9z",
    fill: "#00ADFD"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1178,417)",
    d: "m0 0h6l2 6-2 6v31l-1 10v30l1 2-1 10-3 9-2 53v19l1 28v12l-2 7-9 2-12 1h-203l-24-1v-1l224-1 13-1h10l-1-14v-201l2-6z",
    fill: "#FF4852"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1474,975)",
    d: "m0 0 13 1v1h-9l-5 3v12l5 4 13 5 36 12 20 7 41 14 25 8 80 26 28 8h5l5-5 3-9-4-4-14-7-19-7-20-6-78-26-41-13-30-10-25-7 4-1 24 6 46 14 50 16 63 21 34 13 11 8 2 4-6 12h-2l-2 4h-9l-40-12-30-10-20-6-30-10-13-4-28-10-23-8-25-9-29-9-9-6-1-12 3-7z",
    fill: "#A67C84"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1756,500)",
    d: "m0 0 5 1 9 4v7h-1l-1-5-8-3h-4l-5 5-7 4-12 12-6 7-11 9-4 6-5 4h-2l-2 4-6 7-7 3-20 2-5-3-2-4-4-2-5-6-10-1-1 11 4 9 5 7 10 8 5 3v2l10 5 5-1 17-8 23-23 8-7 13-13 7-8 7-5 3-3-2 5-6 8-7 7-5 6-8 7-8 8-7 8-11 11h-2v2l-17 9-12 1-9-4-9-9-2-1v-2h-2v-2h-2v-2h-2v-2h-2l-6-10-6-17 3-4 8-1 11 2 10 11v2h9l6-2 11-1 4-4h2l2-5 8-7h2l2-4 4-5h2v-2l11-9h2l2-4 11-9 5-3 1-3z",
    fill: "#A67C84"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(830,504)",
    d: "m0 0h102l12 1 1 1v16h-2l-1 5-9-1-2-7-1-3-10-2h-12l-3-1-6 1h-8l-2-1-25-1-10 1-11-1-15-2-5 1-6-1h-8l-12-3-12-1v-1z",
    fill: "#3A4A69"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1066,1320)",
    d: "m0 0h84l6 2 1 2 2 20v70l-1 9-2 4-7 3-6 1-59 2h-16l-16-1-5-6-2-22 1-62 1-14 4-5 7-2zm36 2-37 1-11 1-3 3-1 17v61l2 20 2 4 10 1 84-1 6-3 2-3 1-9-1-58-1-25-2-8-3-1z",
    fill: "#FEABA2"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1793,1379)",
    d: "m0 0h81l-3 2-11 6-8 7-23 12-28 13-22 9-3-1-8-16-8-19 1-2 2 4 2 1 2 7 5 12 3 5 4 4 7-1 19-7 9-5-1-3 1-4-7-1-2-3 3-4h2l2-4 13-8 2-3h-34z",
    fill: "#00ADFD"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1083,1115)",
    d: "m0 0h57l13 3 5 3 1 2 1 11v30l-1 33-1 18-2 7-6 3-5 1-16 1-52 1-18-1-7-1-2-2-3-10-1-10v-60l1-17 1-5h2l2-4 7-2zm16 2-35 1-9 1-3 2-1 7-1 1 1 12-1 7v11l-1 9 1 28 2 23 3 4 3 1 25 1h55l11-1 5-3 2-5 1-54v-39l-8-4-5-1z",
    fill: "#FEA8A0"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1425,1173)",
    d: "m0 0 9 2 46 15 27 10 60 20 43 14 35 11 15 3h8l3-3 1-5h3v-6l-16-8-18-6-28-10-36-12-10-2v-2l-4-2 10 2 30 10 35 12 15 6 11 4 12 5 3 4-1 5-3 9-12 4-1 1-7-1-12-5-33-9-21-7-43-14-26-10-30-9-20-7-18-6-23-7-1-2h3l-6-3z",
    fill: "#A67C84"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1225,1395)",
    d: "m0 0 1 3-2 5-2 149v123l1 68 1 19 1 11-2-3-1-3-1-12-2-71-1-46v-149l-1-17-1-3 1-3v-10l1-5-1-3 1-9v-13l-1-2v-9-4-3l2-1 1-5h2l2-6z",
    fill: "#FF4852"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1650,1389)",
    d: "m0 0h8v14l-4 26-1 10h-2l-2 10-3 1-2-9-1-11-2-6-2-2h-3l-3 10-3 2-1-3h-3v-10l2-4 1-7 3-2 1-8 6-7z",
    fill: "#87EA2D"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1289,1708)",
    d: "m0 0h13l20 1 6 2 2 2v9l-4 10-2 2-23 1-12-3-4-3-1-8 1-10z",
    fill: "#394463"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1184,769)",
    d: "m0 0h1v240l-1 12-5 2h-490v-1l335-1 1-1h157l1-162z",
    fill: "#FEAB95"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(642,1319)",
    d: "m0 0h43l35 1 12 2 3 2 1 4v90l-2 10-5 3-6 1-48 1h-34l-10-1-5-5-1-3-1-11-1-61 1-22 3-7 9-3zm-4 3-9 3-1 1-1 23-1 14 1 51 1 12 3 3 11 2 81-1 9-2 1-1 1-26 1-31v-16l-1-27-2-3-7-1-27-1z",
    fill: "#FEBDA3"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(848,1320)",
    d: "m0 0h58l25 1 11 2 3 5 2 15v64l-1 15-3 6-8 3-7 1-28 1h-53l-9-3-2-3-1-6v-90l3-6zm-3 3-6 4-2 5 1 92 2 4 5 2h87l9-3 4-9v-54l-1-33-3-6-6-2z",
    fill: "#FEAA9A"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1391,1710)",
    d: "m0 0h15l6 2 2 5-1 8-4 6-5 3h-23l-11-3-5-4-1-3v-11l4-2z",
    fill: "#303D5D"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1076,423)",
    d: "m0 0 1 4-4 3-15 2-70 1-194-1-52-1-14-1v-1l81-1h228v1h24l11-1 3-2z",
    fill: "#FE8073"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1635,1384)",
    d: "m0 0 7 1h15l-3 2-19 1-3 2-5 21-2 12-2 36-3 2-27-1-24-1-7 2-3 5-3 4 2-9 7-14 9-15 1 2-2 6h2l2 3 2 7 9 4h12l12-2 3-2 2-26 3-17 5-8 2-1 3-10 1-3z",
    fill: "#00ACFE"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1317,1469)",
    d: "m0 0h43l29 1 2 3v5l-3 2h-18l-19-1h-20l-9 1-4 4-2 10-1 17 1 6v13h-2l-1 2-2-8-1-54z",
    fill: "#2F3C5C"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1733,1765)",
    d: "m0 0h6l6 4 7 12 5 9 4 4 5 1v1h-92v-1l30-1 10-5 6-8 8-12z",
    fill: "#09AFFD"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(882,1115)",
    d: "m0 0h40l12 1 10 5 3 7v72l-1 15-3 8-7 3-10 1h-78l-9-3-3-4-1-5v-84l1-8 6-5 5-2zm-35 3-7 4-1 1-1 20-1 1 1 73 3 5 6 3h78l11-1 6-3 2-5 1-29v-60l-3-5-5-3-12-1z",
    fill: "#FEB5A0"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1461,1711)",
    d: "m0 0h32l3 3 2 7-1 7-8 4h-29l-9-2-2-3-1-12 7-3z",
    fill: "#2F3C5C"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1065,1524)",
    d: "m0 0h70l17 2 3 1 2 5 1 15v78l-3 7-3 3-10 2-51 2h-31l-8-1-3-7-2-15-1-22v-48l1-13 5-7zm35 2-46 1-2 1-2 6-1 12v28l-1 11 2 38 3 11 1 2 3 1h22l56-1 13-1 5-2 3-7 1-59-1-34-3-5-7-1-10-1z",
    fill: "#FEB4A3"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(812,1023)",
    d: "m0 0h367l-3 2-9 1-4 1h-2v-2h-2v2h-2v-2l-5 1-12-1-1 2-4-1-4 1-2-2v2h-22v-2l-3 1-4-1-1 2-7-1h-38l-6-1h-34l-72 1-4 1-3-1-8 1-3-1-1 1h-7-1-8-4l-3-1-9 1-3-1-7 1-5-1h-64z",
    fill: "#FF4852"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(867,1523)",
    d: "m0 0 51 1 18 2 9 3 1 1 1 13v57l-1 27-3 7-1-2 2-6v-95l-11-3h-91v2h-2l-2 16v42l1 38 3 7 2 2 4 1h77l14-1-3 2-6 1-35 1h-46l-8-2-3-3-2-8-1-9v-78l2-9 5-4 6-2z",
    fill: "#FEB4A2"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(641,1116)",
    d: "m0 0h77l11 1 5 4 2 5 1 39-1 43-2 13-3 4-3 1-13 1h-78l-7-3 2-2 5 2h85l7-1 3-4 2-50v-20l-1-25-3-4-21-1h-72l-9 2-1 20v64l1 16-2-1-2-10-1-43v-15l1-26 2-6 7-3z",
    fill: "#FEBEA3"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(856,1614)",
    d: "m0 0 9 3 18 1-4 3 1 4 2 2 10 3 3 3 12-1h16l16 2-4 2-10 1h-77l-1-2 4-2v-3l-2-3 3-7h2l1-4z",
    fill: "#E9EAFE"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1225,1411)",
    d: "m0 0h1v61l-2 117v64l1 90 2 27 3 10-2 1-4-12-1-7-1-19-1-68v-123l2-130 1-1z",
    fill: "#A67B83"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1317,1467)",
    d: "m0 0h42l27 1 9 1 3 2 1 8v15l-1 35-1 20-2 6-12 2-26 1h-17l-19-1-10-2-2-2-1-18v-41l1-25 1-1zm0 2-7 1v60l1 18 3 5 10 1 44 1 25-2 1-1 1-7 1-35v-28l-2-10-5-2-29-1z",
    fill: "#646681"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1473,999)",
    d: "m0 0 7 1 41 13 27 10 35 12 10 4 15 4 36 12 20 6 27 9 27 8 1 2h-10l-10-3-18-6-15-6-10-2-6-2-15-4-12-4-8-3-9-3-16-5-21-8-33-11-7-3-17-6-21-6-8-3-10-5z",
    fill: "#FFA68C"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1775,1740)",
    d: "m0 0v3l-8 8 15 20 9 8 2 5 4 2 3 2 11 2 28 1h25l12-3 7 1 3 4-7 1-20 1-57 1h-23v-1l10-3-1-5-14-15-14-14 1-5 13-12z",
    fill: "#04AEFD"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1047,1122)",
    d: "m0 0h1l-1 22v60l2 14 3 7 7 1 25 1 45-1 16-1 10-3 2-7h1v6l-4 4-5 2-17 2v2l-6-1h-9l-4-1v2l-11 1-6-2-5 2-2-1-17 1-12-1-2-2-7-1-3-3-4-3h-2l-2-5 2-3-1-11 1-3-1-5 1-7 1-9-2-5 2-1-1-7 1-2h-2l-1-4 2-1-1-5h2l-2-6 1-4-1-5 3-11z",
    fill: "#FE4751"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(611,739)",
    d: "m0 0 2 1-1 1-1 10-1 93v158l1 18-2-2-1-5-1-47-1-103v-53l-1-16v-45l2-7z",
    fill: "#FF4852"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1079,1312)",
    d: "m0 0 5 1 1 1 5-2v3l18 1 15 1 19 1 8 1v1l-84 1-12 2-5 3-1 2-1 14-1 62 2 22 4 6-4-1-1-3h-2l-2-12-1-4h2l-1-11v-15l-1-3 1-5-2-2h2l-1-10-2-4 2-1-1-10 1-5 1-2h-2l1-9h2l-1-6 5-6h2v-2l4-1v-2h2l1-2 3 1v-2l10-2h3v2h3v-2z",
    fill: "#FF4852"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1561,1095)",
    d: "m0 0 7 1 54 17 20 6 25 8 12 4 11 5 13 7 1 5-1 9-3 4 1-5v-13l-9-3-10-5-18-6-7-2h-9l-1 3-6-2-6-3-5-1-2 2 1 6 3 3 3 2 2 4-3 1-1-2-5 1-5-5-3-5-5-2-2-4 1-5 1-2 4-1-16-6v-2l-9-2-33-11z",
    fill: "#3F597F"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1252,1387)",
    d: "m0 0h6v1l-18 5-9 6-2 5v66l-1 30-2 65-1 115h-1l-1-27v-64l2-126v-40l1-18 3-9 5-4z",
    fill: "#D9DABA"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(668,735)",
    d: "m0 0h360l78 1v1l-24 1h-447v-1z",
    fill: "#FF4852"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1513,982)",
    d: "m0 0 9 1 32 8 14 4 23 7 53 17 24 8 11 4 13 4 11 5 17 7-3 1-12-3-11-5-38-12-17-6-25-8-37-12-53-16-11-3z",
    fill: "#FFA089"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1642,1382)",
    d: "m0 0h31l-3 2-1 9-2 6-2 15-4 19-2 10v12h12l8-1v2l-19 5h-5l-1-1v-17l1-21 3-18 1-18-2-1h2v-2h-17z",
    fill: "#0CAFFB"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(867,1310)",
    d: "m0 0 5 1h11l10 1v2l5-1h9l7 2 11 2 16 4 1 2-11-1-30-1h-53l-5 1 2-4 8-5z",
    fill: "#FF4852"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1170,428)",
    d: "m0 0 2 1v201l-2-3-1-4v-187z",
    fill: "#FFB492"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1226,1538)",
    d: "m0 0h1v178l1 17v10l1 6v14h2l-1 14 3 1 1 4-4-2-3-5-2-14-1-18v-63l1-115z",
    fill: "#97C6DC"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1017,501)",
    d: "m0 0 46 1 10 2 3 3v10l-3 14-4 3-13 1h-40l-25-2-4-4-1-4v-12l2-7 8-3zm-4 3-16 1-7 2-3 8v8l2 7 1 1 22 2h32l24-2 3-5 3-15-2-5-10-1z",
    fill: "#A67C84"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(624,1210)",
    d: "m0 0h1l2 10 3 2v2l7 2h78l13-1 4-2 2-5 1 4-4 7-17 4h-18l-5 1h-3v-2h-2l-1 2-1-3-8 1h-6l-1-1-11 1-2-1-1 2-2-2-4-1v2h-7v2h-3l-1-2-3-1-1-3-8-6-2-2z",
    fill: "#FE4751"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1604,1627)",
    d: "m0 0 3 1-20 8-13 5-14 7-2 3-1 6 3-1 1 3-4 1v3l7 2 8-1 16-6 14-6 27-9 13-5 16-1 3 3 12 33 3 6-1 2-7-14-5-13-4-10-2-4h-9l-15 4-30 11-24 10-16 5h-7l-4-14v-7l8-5 25-10z",
    fill: "#61E65C"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1796,1584)",
    d: "m0 0h6l2 1 5 13 4 13 6 18 4 10 1 7-3-4-10-28-2-9h-2l-2-3-5-1-4 2-4-1-5-7-11 1-7 1h-9l3-2z",
    fill: "#00ADFE"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(942,1323)",
    d: "m0 0 4 3 3 13v82l-3 7-12 6-3 2-4-1-5 1v2h-14l-1-3-5 2-13 1-5-2-7 1-2-1h-4l-1 2h-5v-2l-21-2-2-2h58l28-1 10-2 5-2 2-5 1-15v-64l-2-15z",
    fill: "#FE4751"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(936,1115)",
    d: "m0 0 8 4 3 4 1 3 1 16v71l-2 3 2 1-3 7-6 4-6 2-1-1h-6l-3 3h-7l-5-1h-2v-2h-11v2l-6-1-2-1v2l-4-1h-10l-7 2-12-1h-11l-4-5h83l13-2 3-1 3-8 1-15v-72l-2-6-10-5z",
    fill: "#FE4751"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1154,1326)",
    d: "m0 0 2 4v15h2v78l-2 4-7 3-6 1h-86l-5-2-2-7-1-10v-69l1-14h1v76l2 20 1 3 10 1 84-1 6-3 2-7-1-62z",
    fill: "#FECDA7"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(845,1321)",
    d: "m0 0 71 1v1l-71 1-5 3-2 5 1 92 1 4 5 1 71 1v1h-72l-7-2-2-8v-90l3-6z",
    fill: "#FED0A7"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1874,1379)",
    d: "m0 0h8l8 2 4 4-4 9-7 8-15 10-7 4-2-1 18-12 1-7h-12l-2-1v-2l-2-1 10-5-3-2h-6l4-3z",
    fill: "#61E55C"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(692,1108)",
    d: "m0 0h11l5 2 1-2 4 3 5 1v2l9 1 4 2-2 1-18-1h-77l4-3 10-1 11-2 4 1v-2l12-1 4 1 2-1 4 1z",
    fill: "#FF4852"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1389,1705)",
    d: "m0 0h15l9 2 3 2 3 13-1 7-7 6-9 2-17-1-15-3-6-4-2-5v-12l3-3zm2 5-23 1-4 2v11l3 5 5 3 9 2h23l5-3 4-6 1-8-2-5-6-2z",
    fill: "#98C7DC"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1704,1733)",
    d: "m0 0 4 4 8 13v5l-9 7-15 9-12 9-6 5-5 5-4 3-5 1h-8l-8-7v-3l6 5 6 1 10-7 9-5h3l2-4 5-3 10-5 6-7 5-4v-7l-3-12z",
    fill: "#00ADFD"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1784,1534)",
    d: "m0 0 2 3 8 18-1 5-16 6-30 10-44 16-29 10-4 1-3-15 3 1 1 4 3 1 14-1 21-6 20-7 11-4 20-7 14-5h2v-2l5-2 3-8 2-5h2l-4-9z",
    fill: "#00ADFD"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1519,1081)",
    d: "m0 0 10 2 8 3v2l6 1-2 2v3l-5 1-1 9 3-1 4 2 1 4h2l2 2 4 3-1 2h-6l-4-4-5-2v-3l-4-2-6-4-3-5-5-4-1-4 3-5z",
    fill: "#445B7F"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1839,1702)",
    d: "m0 0 4 1 5 11 8 24-3-1-1-2-4-1-5-8-3-8-3-2h-9l-9 3-10 1 3-3 13-7z",
    fill: "#00ADFD"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(714,1116)",
    d: "m0 0 15 1 5 4 2 5 1 39-1 43-2 13-3 4-3 1-13 1h-78l-7-3 2-2 5 2h85l7-1 3-4 2-50v-20l-1-25-5-5-14-1z",
    fill: "#FEC2A3"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1831,1429)",
    d: "m0 0 3 1-16 8-15 7-15 6h-2l4 15 5 15 10 25 11 29 4 14 7-1 12-5 14-6 3 1-13 6-20 9-3 1h-9l-1-3 2-3h2l-1-13-13-35-9-22-7-23-1-4 5-4 13-4 18-8z",
    fill: "#61E65C"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1545,1502)",
    d: "m0 0 1 4-4 21-2 26 1 17 1 21 6 39 2 9 8 1 5-2 7-1 6-3 9-2 9-3 13-5 3 1-8 4-25 9-19 8-2 1h-6l-4-16-6-37-2-17v-36l4-27z",
    fill: "#00ADFE"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1157,1131)",
    d: "m0 0h1v84l-2 7-6 3-5 1-16 1h-39l-34-2-5-5-1-6-1-16v-30h1l1 28 2 23 2 3 3 1 25 1h55l11-1 4-2 2-5 1-54z",
    fill: "#FED3A4"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1737,1379)",
    d: "m0 0h15l8 11 11 25 5 10v2l6-1 12-5 9-4 3 1-11 5-13 6h-6l-5-8-5-10-8-20-4-6h-7v3l1 3 3 1v6l-4 1h-3l3 15 1 6-3-4-5-16-3-14z",
    fill: "#61E65C"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(868,1516)",
    d: "m0 0 8 1 14 1h2v2l10-3 3 3h5v2h10l15 3v1l-17-1-51-1-19 1-6 1 4-4 13-5 9 1z",
    fill: "#FF4852"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(836,1549)",
    d: "m0 0h1l1 14v25l1 38 3 7 2 2 4 1h77l14-1-3 2-6 1-35 1h-46l-8-2-3-3-2-8-1-9v-67z",
    fill: "#FDB1A3"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(656,1312)",
    d: "m0 0 7 1 3-1 5 2 2 1h8l6-1v2l10-1 6 1 25 4 4 2-12-1-35-1h-43l-16 4v-2l12-5 7-4 7 1z",
    fill: "#FF4852"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1295,1704)",
    d: "m0 0 25 1 8 2 4 5 2 15-6 7-4 2h-25l-13-3-4-5-1-10 2-10 2-2zm-6 4-4 3-1 11 1 7 6 4 13 2 20-1 3-3 3-9v-9l-3-3-5-1-20-1z",
    fill: "#98C7DC"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1475,1706)",
    d: "m0 0h13l8 4 3 7 1 5v7l-5 4-10 2h-12l-21-3-4-2v-2h-2v-14l3-3 9-3zm-14 5-12 3-1 5 2 10 4 2 6 1h29l8-4 1-7-3-9-2-1z",
    fill: "#98C4D8"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(628,1324)",
    d: "m0 0 2 1-1 1-1 23-1 14 1 51 1 14 17 2h22l-2 2h-35l-5-5-1-3-1-11-1-61 3-9 1-18z",
    fill: "#FEB2A2"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1480,1190)",
    d: "m0 0h6l3 2 7 2 27 9 4 2 12 2 4 2v2l11 2 5 2 39 13 13 4 20 7 14 5-3 1-42-13-72-24-35-12-13-5z",
    fill: "#405A80"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(510,1217)",
    d: "m0 0 2 2 1 179 1 29v18l-1 7 12 1 12 2v1l-15-1-9-1-2-1z",
    fill: "#FF4852"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1149,1429)",
    d: "m0 0 3 1-4 2-9 1v2l-7 1h-13l-7 1-3-1h-14l-1 2-7 1-2-3-6 2-8-1-2-2-17-2v-1h32l59-2z",
    fill: "#FF4852"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1650,1538)",
    d: "m0 0h2l5 13 5 20 2 17-1 8-3-3-2-10-3-6-4-13-1-3-1-21z",
    fill: "#88EB2D"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(611,907)",
    d: "m0 0h1v89l1 19 2 4 17 1 56 1v2h-68l-7-1-3-5v-101z",
    fill: "#FEB0A3"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1636,1578)",
    d: "m0 0 2 3 9 26 1 4-1 2-33 11v-2l13-5 6-10 3-16 2-1-2-8z",
    fill: "#01ADFD"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(943,522)",
    d: "m0 0h1v12l-4 1h-202l-8-3-3-4 4 2 5 2 18 1h131l43-1 7-1h8z",
    fill: "#A57B83"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1908,1517)",
    d: "m0 0h5v19l-6 4-16 7-12 6-9 4-3-1 20-9 12-7 12-5 1-2-10-1-4-4-1-5-25 9-3-1 20-8z",
    fill: "#61E65C"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1756,1459)",
    d: "m0 0 5 1 3 7 4 16 3 10 6 15 7 20 7 16 6 13-2 4-12 5-14 4h-5l3-2 19-6 7-3-1-6-8-19-6-15-5-15-5-12-5-17-3-11v-3l-16 6-19 6-16 4h-5l1-2 16-4 17-5 15-5z",
    fill: "#61E65C"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(945,1143)",
    d: "m0 0h1v72l-3 8-7 3-10 1h-78l-9-3 1-4 4 3 3 1h78l11-1 5-2 2-5 1-29z",
    fill: "#FEBBA1"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1151,1528)",
    d: "m0 0 4 2v31h-3l-3-4-3-12-10-9 2-4 10-2z",
    fill: "#DDEDFE"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1654,561)",
    d: "m0 0 4 1v2l4 2 3 5 5 3 9-1 3-1 2 2-3 7-2 5-2 2-3 1-7-4-9-11-5-10z",
    fill: "#394A69"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(618,417)",
    d: "m0 0h2l1 2 2 54v156h-1l-1-26v-89l-1-34-1-48z",
    fill: "#FF4852"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1653,1126)",
    d: "m0 0 7 1 16 5 15 6 10 5 1 2v11l-3 4-2-3 3-5-1-6-5 4-4-1-4-4-1-4h2l-3-3-4-2 1 4-1 2h-10l-7-2 1-4 5-4-16-5z",
    fill: "#3F597F"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(610,833)",
    d: "m0 0h2v73l-1 10-1 86h-1v-158z",
    fill: "#F8A199"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1391,1535)",
    d: "m0 0h2l1 7-1 9-10 2-22 1-17-1 1-4 8-2h30l4-1 1-4z",
    fill: "#2F3C5C"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1066,1320)",
    d: "m0 0h84l6 2 1 2 2 20v70h-1v-69h-2l-1-19h-2v-3l-95-1v-1z",
    fill: "#FEA499"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1561,1095)",
    d: "m0 0 7 1 54 17 20 6 25 8 12 4 11 5 13 7 1 5-1 9-3 4 1-5v-13l-9-3-10-5-18-6-30-9-43-14-30-10z",
    fill: "#A67C84"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1654,1386)",
    d: "m0 0h5l1 7-3 24-2 12h-1v-8l3-18 1-14-12 2-4 2h-3l-2 4-3 3-1 8-4 2v7l-3 6h-1l1-12 5-21 4-3z",
    fill: "#61E65C"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1560,1093)",
    d: "m0 0 10 2 37 11 27 7 9 3 21 8 15 5 8 4-4 1-12-5-17-5-28-9-39-12-22-7-7-1z",
    fill: "#FEA089"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1654,1489)",
    d: "m0 0 4 1-3 2-2 9v13l1 5 5 5 2 3v6l-3 7h2l1 8 2 12 5 21 1 8-2-1-4-16-7-29-6-30v-20z",
    fill: "#00ADFE"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(904,1110)",
    d: "m0 0 3 1 7-1v2h9l10 3v1h-51l-38 1 4-3 13-1h8l2-1h12l5-1 16 1z",
    fill: "#FF4852"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1756,1461)",
    d: "m0 0h4l7 25 3 8 6 15-1 4-4-9-4-11-5-15v-2l-11 1-5-5-2-3-3-2z",
    fill: "#00ADFD"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1099,1115)",
    d: "m0 0h41l13 3 5 3 1 2 1 11v30l-1 33h-1l-1-66-1-8-7-3-5-1-45-1h-20v-1l19-1z",
    fill: "#FEB39E"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1747,1423)",
    d: "m0 0h2l4 10v5l-13 4-45 10-12 3-4-1 3-2 22-5 18-5 21-6 1-1 1-11z",
    fill: "#08AEFC"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1065,1524)",
    d: "m0 0h70v1h-68v2l-15 1-2 18v28l-1 9h-2v11h-1v-48l1-13 5-7z",
    fill: "#FEA49B"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(882,1115)",
    d: "m0 0h40l12 1 10 5 3 7v72h-1l-1-57-1-16-3-5-4-2-12-1-56-1 1-2z",
    fill: "#FEAD9E"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1166,639)",
    d: "m0 0h11v1l-9 2-12 1h-203l-24-1v-1l224-1z",
    fill: "#FF4852"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1648,1639)",
    d: "m0 0h9l3 5 6 16 5 12-1 2-7-13-2-1v-2l-4-2-9-5-4-6 1-3-2-2z",
    fill: "#09AEFB"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1704,556)",
    d: "m0 0h3v6l-4 2v9l-4 7-6 5-5-1-1-7v-4h2v-2l10-7 1-2h2l1-5z",
    fill: "#394A69"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1360,1468)",
    d: "m0 0h26l9 1 3 2 1 8v15l-1 35-1 1-1 15h-1v-63l-2-10-4-1-29-1z",
    fill: "#596281"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1069,1618)",
    d: "m0 0 17 3 5 3 3 3-3 2-5 1h-10l-1 2-6-2-5-2 1-7h3z",
    fill: "#E9EAFE"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1483,978)",
    d: "m0 0 8 1 6 2 9 1v2l7 2-3 6-5 1-12-3-7-3-4-3v-5z",
    fill: "#2F3C5C"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1855,1740)",
    d: "m0 0h2l11 23 8 15 3 6-4-1-9-1-3-4-2-17-2-10-4-9z",
    fill: "#04ADFD"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1570,1667)",
    d: "m0 0 2 1-8 3v9l2 3v2l3 1 3 6 3 5 7 14 7 10 14 19 3 3-1 2-8-9-13-18-8-11-11-16-7-15 1-5z",
    fill: "#01ADFD"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(613,739)",
    d: "m0 0h30v1l-25 1-4 1-2 91h-2v-83l1-9z",
    fill: "#FEACA2"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1708,1617)",
    d: "m0 0 3 1-9 4-8 4-2 4-2 2-3 9 4 8v2l4 2 1 6 6 11-1 2-9-14-8-16-5-9v-5l8-3 17-6z",
    fill: "#00ADFE"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1608,1477)",
    d: "m0 0 7 1 3 2 10 1 2 4-2 4h-5l-7-3-20-1-4-2 1-3 3-1h8z",
    fill: "#88EB2D"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1076,1518)",
    d: "m0 0h5v2l4-2 4 1-1 1 2 1 1-2 6 2h17l21 2v1l-70 1-13 1 4-3 12-3v2h2v-2h6z",
    fill: "#FF4852"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1747,517)",
    d: "m0 0h2l1 3-6 7-5 9-8 8-3 2-4-1-1-1v-5l5-4 7-8 3-3 5-2 1-3z",
    fill: "#394A69"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(836,1121)",
    d: "m0 0 2 1-1 1-1 8v84l2 7 3 3-4-1-2-2-2-13v-27l-1-22v-8l-1-5v-3h2v-4h-2v-6h2v-2h-2v-2l2-1 2-7z",
    fill: "#FE4751"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1174,745)",
    d: "m0 0 6 1 2 1 1 3v57h-1l-1-26-1-10-3-3-3-13-2-8z",
    fill: "#A9DAF2"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1317,1467)",
    d: "m0 0h42l1 2-43 1-6 1v77h-1l-2-13v-41l1-25 1-1z",
    fill: "#666681"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1584,1202)",
    d: "m0 0 7 1 16 6 9 1 1 3 3 2v2h-7l-6-1-6 1-9-3-4-5v-4l-4-1z",
    fill: "#2F3D5D"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1391,1710)",
    d: "m0 0h15l6 2 2 5-1 8-4 6-5 3h-23l-9-2v-1h33l4-4 2-4v-7l-4-2h-40l-2 10h-1v-11l4-2z",
    fill: "#61607A"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1661,1227)",
    d: "m0 0 9 3 6 4-1 6-3 1v5l-4 3h-8l-15-3v-1h10l6 2h6v-4l-5-3-5-4v-5l4-1z",
    fill: "#405A80"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1178,417)",
    d: "m0 0 4 1-4 6-1 3-1 198h-1v-201l2-6z",
    fill: "#FE9F8A"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1571,1099)",
    d: "m0 0 9 2-3 1 4 13 10 8 1 3-4 2v-2l-4-2-6-4-10-10-3-4v-2h5l1-2 3 1z",
    fill: "#405A80"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1832,1666)",
    d: "m0 0 2 3 4 9v6l-9 3-17 5-25 12-9 5-2-1 8-5 19-10 14-6 8-3 5-7 1-4h2z",
    fill: "#00ADFE"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1157,1324)",
    d: "m0 0 2 3 2 20v13l1 6v52l-3 7-3 2 2-13v-70l-1-11z",
    fill: "#FF4852"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1050,1526)",
    d: "m0 0 2 1-4 6-1 13v48l1 22 1 7v8l-2-4-1-1-1-16-1-35-1-19-1-7 2-10 2-8z",
    fill: "#FF4852"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1896,1765)",
    d: "m0 0 2 4 1 5v15l-7 3-6 1-7-6-2-5-4-8 1-2 6 9h10l3 2 4-1v-7z",
    fill: "#61E55C"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(836,1326)",
    d: "m0 0 1 2-1 3v96l-2-4-1-11-1-62-1-4 1-14z",
    fill: "#FF4852"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1610,1623)",
    d: "m0 0m-3 1 3 1-8 4-25 9-19 8-2 1h-6l-2-9 6 2 6-1 10-2 6-3 9-2 9-3z",
    fill: "#00ADFE"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(938,1529)",
    d: "m0 0 6 1 1 1v18l-2-3h-5l-2-4-4-2-5-3v-3l9-3h2z",
    fill: "#DEEDFE"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1063,1113)",
    d: "m0 0h72l12 2 6 2-3 1-13-2h-54l-27 1 2-2z",
    fill: "#FF4852"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(642,1319)",
    d: "m0 0h43v1l-14 2-33 1-10 2-1 18-2 4h-1v-17l3-7 9-3z",
    fill: "#FEA69E"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1478,976)",
    d: "m0 0 14 1 11 3v2l-9-1-7-2h-9l-4 2v7l1 4 5 2 6 3 24 7 6 4-3 1-33-11-6-4-2-2v-12l3-3z",
    fill: "#405A80"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1474,1071)",
    d: "m0 0h7l-1 6 6 1 3 3-1 2-5 3-6-1-3-2v-2h-3l-5-5 1-3z",
    fill: "#405A80"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(641,1116)",
    d: "m0 0h70l3 1 14 1v1h-91l-9 2 2-3z",
    fill: "#FEAC9C"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(930,1637)",
    d: "m0 0h6v1l-13 3h-73l-6-2v-1h51z",
    fill: "#FF4852"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1170,744)",
    d: "m0 0h4l-1 5 3 8 2 11 3 3 1 10v22h-1l-2-18-2-4 1-5 1-2-5-7-1-9-4-4v-2l-4-2-1-4z",
    fill: "#E9EAFE"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(723,1431)",
    d: "m0 0h6l-4 2-1 2h-43l-45-1-1-2h40z",
    fill: "#FF4852"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1461,1711)",
    d: "m0 0h32l3 3 2 7-1 7-8 4h-29l-9-2 4-1 6 1h27l5-3h2v-9l-1-5-31 1-13 2-2 2 1-4z",
    fill: "#656580"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1793,1448)",
    d: "m0 0 3 1-5 2-3-1zm-7 3h2l2 11 9 25 7 18 11 28 3 6 1 6 3 3v2l-5-1-6-20-10-26-11-27-6-20z",
    fill: "#01ADFD"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(489,1454)",
    d: "m0 0h8v3l-14 2-33 6-16 4 1-3 10-3 16-4 9-2z",
    fill: "#FE9E88"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1666,1063)",
    d: "m0 0 7 1 22 7 23 7 1 2h-10l-10-3-18-6-15-6z",
    fill: "#FFAD8F"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(732,1427)",
    d: "m0 0 2 1-5 3-6 1-48 1h-34v-1l25-1 2-1 55-1z",
    fill: "#FEA49A"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1640,1235)",
    d: "m0 0 10 5 8 1 5-1 6 4-2 4h-6l-8-2-10-2v-2l-4-2z",
    fill: "#313F5F"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(839,1526)",
    d: "m0 0 3 1-4 3-2 9v78l1 15h-1l-2-14-2-73 3-15z",
    fill: "#FF4852"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(625,1324)",
    d: "m0 0 1 2-1 4-1 22 1 71h-1l-1-9-2-66v-15l3-8z",
    fill: "#FF4852"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(942,1323)",
    d: "m0 0 4 3 3 13v82l-3 7-6 3-3-1 6-3 2-5 1-15v-64l-2-15z",
    fill: "#FF4852"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1703,1589)",
    d: "m0 0m-36-1 3 1 1 4 3 1 14-1 11-3h4v2l-29 10-4 1-2-10z",
    fill: "#0BAEFB"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1271,1383)",
    d: "m0 0h8v1l-27 4-18 5-5 5-3 13-1 10-2 1v-19l4-9 4-3 19-5z",
    fill: "#FEA79D"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1571,1193)",
    d: "m0 0 12 2 19 7 16 5 18 6 13 6 5 2-4 1-20-8-36-12-23-8z",
    fill: "#FFA98D"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(626,1363)",
    d: "m0 0h1l1 51 1 14 17 2h22l-2 2h-35l-5-5z",
    fill: "#FED0A4"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1047,1583)",
    d: "m0 0 2 2 2 38 3 13 25 1v1h-27l-3-7-2-15z",
    fill: "#FEC2A4"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1592,1136)",
    d: "m0 0 8 1 41 14 20 6 17 5-4 1-16-4-13-4-16-5-37-13z",
    fill: "#FFA18A"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(943,522)",
    d: "m0 0h1v12l-4 1h-55l1-2 42-1 7-1h8z",
    fill: "#A67C84"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1778,1708)",
    d: "m0 0 2 1-16 12-11 8-4 1-1 3-9 4h-4l-13-26 1-2 13 23 2 2 10-5 13-9z",
    fill: "#61E65C"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(867,1523)",
    d: "m0 0 51 1v1l-69 1-7 2v2h-2l-2 16-2 4h-1v-11l2-9 5-4 6-2z",
    fill: "#FEA495"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1774,1709)",
    d: "m0 0 2 1-16 12-17 11-6 2-8-13 1-2 5 7 5 2v-2h7l18-12z",
    fill: "#05ADFC"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1841,1569)",
    d: "m0 0 2 1-6 8-4 3 2 8 9 21 4 9-1 3-11-24-8-21 4-4z",
    fill: "#01ADFD"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(624,1122)",
    d: "m0 0 1 4-1 26v58h-1l-1-6v-20l-1-57z",
    fill: "#FF4852"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(945,1143)",
    d: "m0 0h1v72l-3 8-4 2h-14v-1l11-1 5-2 2-5 1-29z",
    fill: "#FECAA6"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(936,1115)",
    d: "m0 0 8 4 3 4 1 3 1 16v71l-3 2v-87l-2-6-10-5z",
    fill: "#FF4852"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1497,1717)",
    d: "m0 0h2l1 5v7l-5 4-10 2h-12l-21-3v-2l8 1h29l7-3 1-7z",
    fill: "#98C7DC"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(552,1583)",
    d: "m0 0 1 2h2l3 5 2 5-1 4h-3l-1-2-7-2-2-2-1-7 7-1z",
    fill: "#FF9E86"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1637,1221)",
    d: "m0 0 4 1 4 2 7 2 1 3-2 2-1 2-4-2h-7l-4 1-3-5v-2l5-1z",
    fill: "#2F3C5C"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(677,1320)",
    d: "m0 0h43l7 1 2 3-58-2v-1z",
    fill: "#FEB4A4"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1252,1387)",
    d: "m0 0h6v1l-18 5-9 6-2 5-2 32-2 4v-17l1-18 3-9 5-4z",
    fill: "#FFE5A7"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1649,1046)",
    d: "m0 0 9 2 9 5 4 2 2 4h-7l-6-2-3-3-10-3-1-4z",
    fill: "#2F3C5C"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1710,1378)",
    d: "m0 0h51v1h-24v7l-4-4-4-1h-32v-2z",
    fill: "#C7E0EC"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1669,1145)",
    d: "m0 0 6 1v2l5 2 3 1v2l5 2 3 4-5 1-1-2-9-2-6-7z",
    fill: "#405A80"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1047,1417)",
    d: "m0 0h1l2 11 7 2 64 1v1l-37 1h-16l-16-1-5-6z",
    fill: "#FEA090"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(845,1321)",
    d: "m0 0 71 1v1l-71 1-5 3-3 5-1-4 4-4z",
    fill: "#FEC3A7"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1410,1712)",
    d: "m0 0h2l2 5-1 8-4 6-5 3h-23l-9-2v-1h33l4-4 2-4v-7z",
    fill: "#696781"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1176,593)",
    d: "m0 0h2l1 28v12l-2 6h-1z",
    fill: "#FF545A"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1760,1390)",
    d: "m0 0 3 2v2l2 1 2 7 5 12 3 5 4 4 5 1v2l-6 2-3-3-8-16-7-17z",
    fill: "#04ADFC"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(847,1116)",
    d: "m0 0h23l-1 2-15 1h-7l-7 4-1 20-2 1v-22l5-4z",
    fill: "#FEBAA1"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1734,1591)",
    d: "m0 0 2 1-4 5-10 3-8 4h-4l2-4 7-4 6-1 4-1v-2z",
    fill: "#61E65C"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1588,1384)",
    d: "m0 0h18l-4 6-9 6h-2l1-4 3-6-7-1z",
    fill: "#D8E5F9"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1866,1530)",
    d: "m0 0m-3 1h3v2l-29 12-10 4-2-1 3-4 13-4z",
    fill: "#08AEFC"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1863,1658)",
    d: "m0 0 4 4v2l2-1h7l8-3h3v2l-12 5-4 3-3-1-5-9z",
    fill: "#00ADFE"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1157,1178)",
    d: "m0 0h1v37l-2 7-6 3-10 1 1-2 10-2 3-3 2-12z",
    fill: "#FEABA6"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1563,1192)",
    d: "m0 0 10 2 30 10 3 3-9-2-22-8-8-1v-2z",
    fill: "#A67C84"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1754,1583)",
    d: "m0 0h3l1 3-8 4-14 4 1-3 3-1 3-4 9-2z",
    fill: "#61E65C"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1471,1173)",
    d: "m0 0h6l11 4 2 3-1 1-10-1-7-3z",
    fill: "#394A69"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1752,1379)",
    d: "m0 0h20l-3 3-7 3h-6z",
    fill: "#00ADFE"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1878,1784)",
    d: "m0 0 20 4-3 3-9 2-7-6z",
    fill: "#354567"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1594,1642)",
    d: "m0 0h7l-1 3-8 3h-3v2h-7l-1-3h2v-2l8-2z",
    fill: "#61E65C"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1050,1220)",
    d: "m0 0h2l4 4 34 2v1l-13 1-18-1-7-1-2-2z",
    fill: "#FEA39A"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1230,1780)",
    d: "m0 0 6 4 7 7v1h-10l-2-7z",
    fill: "#303D5E"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1647,1482)",
    d: "m0 0 4 1-1 5-6 4-2 2-2-4 1-5z",
    fill: "#88EB2D"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1808,1515)",
    d: "m0 0h2l9 23 3 9 2 1v2l-5-1-6-20-5-12z",
    fill: "#3EB7F0"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1616,1222)",
    d: "m0 0 4 1-1 4 4 2 1 5-6-1-5-4 2-5z",
    fill: "#2F3C5C"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(945,1417)",
    d: "m0 0h1l-1 8-4 4-6 2-7 1h-12l1-2 15-1 9-3z",
    fill: "#FEA7A2"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(732,1219)",
    d: "m0 0 1 4-5 3-13 1h-17l1-2 23-1 7-1z",
    fill: "#FEAD9E"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1619,1208)",
    d: "m0 0 12 3 18 8 5 2-4 1-20-8-11-4z",
    fill: "#FFA48B"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1396,1530)",
    d: "m0 0h1v19l-2 6-12 1 1-3 9-1 2-7z",
    fill: "#7A6D82"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1252,1387)",
    d: "m0 0h6v1l-18 5-9 6-2 5h-1v-6l5-5 8-3z",
    fill: "#F8F8FE"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1588,1394)",
    d: "m0 0 1 2-6 12-7 11-2 1 1-5 5-9 6-9z",
    fill: "#98C7DC"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(936,506)",
    d: "m0 0h7l1 4-1 4-4 1-3-1v-3l-2-1z",
    fill: "#2F3C5C"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1630,1383)",
    d: "m0 0h29v2l-19 1-5-1h-4l1 3h-2z",
    fill: "#405A80"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(727,1324)",
    d: "m0 0h5l2 3v32h-1v-25l-4-1-1-3h3v-4z",
    fill: "#E6ECFE"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1848,946)",
    d: "m0 0h8l1 4-3 1h-8l-4-1v-2z",
    fill: "#FEDC57"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1225,1398)",
    d: "m0 0h1v13l-1 10-2 1v-19z",
    fill: "#FF9F89"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1051,1531)",
    d: "m0 0h1v17l-1 2-1 21h-1v-25l1-12z",
    fill: "#E9EAFE"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(537,1456)",
    d: "m0 0h13v2l10 2h3v2l4 1-2 1-22-6-6-1z",
    fill: "#FF4852"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1757,1597)",
    d: "m0 0 3 1-10 4-8 3-10 4-3-1 12-5z",
    fill: "#00ADFE"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1056,1117)",
    d: "m0 0h9l-1 2-9 1-2 1-1 7-4-2v-4h2l2-4z",
    fill: "#FEB6A5"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1790,1790)",
    d: "m0 0 5 4 7 1v1h-23v-1l10-3z",
    fill: "#9ECEE4"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1762,1764)",
    d: "m0 0 5 2 3 4v4l-5-1-3-4z",
    fill: "#88EB2D"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(835,1407)",
    d: "m0 0h2l1 18 3 5-4-1-2-8z",
    fill: "#FEA49D"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1860,1386)",
    d: "m0 0 2 1-10 9-12 6-3-1 15-8z",
    fill: "#61E65C"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1595,1386)",
    d: "m0 0 4 1 1 5-7 4h-2l1-4z",
    fill: "#FBFCFD"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1699,1448)",
    d: "m0 0m-3 1h3v2l-16 4-4-1 3-2z",
    fill: "#00ADFE"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1537,1087)",
    d: "m0 0h7l12 4 2 3-6-1-15-5z",
    fill: "#CE9289"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1444,1061)",
    d: "m0 0h8l-3 6h-7z",
    fill: "#626581"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1689,1707)",
    d: "m0 0 4 4 7 12-1 2-3-3-4-7v-3h-3z",
    fill: "#00ACFE"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1622,1215)",
    d: "m0 0 8 1 1 5h-6l-2-1v-3l-2-1z",
    fill: "#2F3D5D"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1441,1067)",
    d: "m0 0h1l1 17 3 2-5-1-2-5z",
    fill: "#8A7383"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(610,1007)",
    d: "m0 0 2 2 2 9 3 2v2l-5-1-2-4z",
    fill: "#FEA399"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(726,517)",
    d: "m0 0 4 3v8h-3l-2-10z",
    fill: "#394A69"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1563,1192)",
    d: "m0 0 10 2 9 3 1 2-6-1-10-2v-2z",
    fill: "#917481"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1416,1170)",
    d: "m0 0 9 3 8 4-3 1-5-1-9-6z",
    fill: "#FFE5A7"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1774,1709)",
    d: "m0 0 2 1-16 12-2-1 8-7z",
    fill: "#00ADFE"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1616,1211)",
    d: "m0 0 9 2 5 2v1h-10l-4-3z",
    fill: "#3C5173"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1552,1097)",
    d: "m0 0 6 1v2l4-1 1 3h-7l-5-2z",
    fill: "#2F3C5C"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1487,977)",
    d: "m0 0 8 1 8 2v2l-9-1-7-2z",
    fill: "#6C657B"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(943,1216)",
    d: "m0 0h1l-1 7-4 2h-14v-1l11-1 5-2z",
    fill: "#FEC8A4"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(625,1205)",
    d: "m0 0h2l1 16-2-1-1-3z",
    fill: "#FBBFA4"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(728,1322)",
    d: "m0 0 6 1 2 5v9l-2-4-2-8-4-2z",
    fill: "#FEA799"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1658,1157)",
    d: "m0 0 9 2 11 3-4 1-16-4z",
    fill: "#FF9F89"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1712,1445)",
    d: "m0 0m-6 1h6v2l-13 3 1-3z",
    fill: "#0AAEFB"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(945,1417)",
    d: "m0 0h1l-1 8-4 4-4-1 4-2z",
    fill: "#FEB6A2"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1178,417)",
    d: "m0 0 4 1-4 6-2 4-1-4 2-6z",
    fill: "#FEA48F"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1571,1193)",
    d: "m0 0 12 2 6 3-3 1-15-5z",
    fill: "#FFA38B"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1547,1187)",
    d: "m0 0 9 2 6 2v1h-7l-6-2v-2z",
    fill: "#73687D"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1610,1623)",
    d: "m0 0m-3 1 3 1-8 4-7 2v-2z",
    fill: "#1BB1F7"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1233,1393)",
    d: "m0 0 3 2-5 4-2 5h-1v-6z",
    fill: "#F2F2FE"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1228,1393)",
    d: "m0 0h5l-4 5-2 7h-1v-10z",
    fill: "#FEAFA4"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1639,1219)",
    d: "m0 0 10 3 3 2-8 1-5-5z",
    fill: "#3D5376"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(1670,1597)",
    d: "m0 0 2 2 11-1-4 2-9 3z",
    fill: "#9BCBE1"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(624,1210)",
    d: "m0 0h1l2 10 3 2v2l2 1-4-1-4-4z",
    fill: "#F44E57"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPos);
export default __webpack_public_path__ + "static/media/pos.456afd95b8e99c602609564fdb793e53.svg";
export { ForwardRef as ReactComponent };